module.exports = __webpack_public_path__ + "static/media/logo_pl_invert_fr.803d10a1.svg";